import { Reducer } from "redux";

import { CareTypeResponse } from "../models/Api/ServiceRequest";
import { CareTypeDispatchTypes } from "../models/DispatchTypes/ServiceRequest";
import { CareTypeActionDispatchTypes } from "../constants/ServiceRequest";

const initialState: CareTypeResponse = {
  loading: false,
  response: [],
};

const CareTypeReducer: Reducer<CareTypeResponse, CareTypeDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CareTypeActionDispatchTypes.CARE_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default CareTypeReducer;
